import Toast from "vue-toastification";
import { useToast } from "vue-toastification";


// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const toast = useToast()

const options = {
   position: "top-right",
   timeout: 3000,
   closeOnClick: false,
   pauseOnFocusLoss: true,
   pauseOnHover: true,
   draggable: false,
   draggablePercent: 0.6,
   showCloseButtonOnHover: false,
   hideProgressBar: true,
   closeButton: "button",
   icon: true,
   rtl: false
 };

export default {
   install: (app) => {
     app.use(Toast, options);
     const wrappedToast = {
       ...toast,
       error(message, options) {
         if (!message) return;
         return toast.error(message, options);
       },
       success(message, options) {
         if (!message) return;
         return toast.success(message, options);
       },
       info(message, options) {
         if (!message) return;
         return toast.info(message, options);
       },
       warning(message, options) {
         if (!message) return;
         return toast.warning(message, options);
       }
     };
     app.config.globalProperties.$toast = wrappedToast;
   }
 }